import React from "react";
import './button.scss';

export const Button = ({className = "", children, onClick}: React.PropsWithChildren<{className?: string, onClick: () => void}>) => {
    return <div className={"button " + className} onClick={onClick}>{children}</div>
}
